// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Breadcrumb
export const EDITAR_BREADCRUMB = 'EDITAR_BREADCRUMB';

// Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// Auth
export const AUTH = {
    LOGIN: 'LOGIN', 
    LOGIN_ERROR: 'LOGIN_ERROR', 
    REGISTER: 'REGISTER', 
    REGISTER_ERROR: 'REGISTER_ERROR', 
    OBTENER_USUARIO: 'OBTENER_USUARIO', 
    OBTENER_USUARIO_ERROR: 'OBTENER_USUARIO_ERROR', 
    LOGOUT: 'LOGOUT', 
    RECUPERAR_USUARIO: 'RECUPERAR_USUARIO', 
    RESTABLECER_USUARIO: 'RESTABLECER_USUARIO', 
    MEMBRESIA_USUARIO: 'MEMBRESIA_USUARIO', 
};

// Dashboard
export const DASHBOARD = {
    OBTENER: 'OBTENER_DASHBOARD'
};

// Asesorias
export const ASESORIAS = {
    BUSCAR: 'BUSCAR_ASESORIAS',
    DETALLES: 'DETALLES_ASESORIA',
    ASESOR: 'ASESOR_ASESORIA',
    ELIMINAR: 'ELIMINAR_ASESORIA',
    FILTROS: 'FILTRAR_ASESORIAS',
    ARCHIVOS: {
        LISTAR: 'LISTAR_ARCHIVOS_ASESORIA',
        DETALLES: 'DETALLES_ARCHIVO_ASESORIA'
    }
};

// Membresia
export const MEMBRESIA = {
    DETALLES: 'DETALLES_MEMBRESIA',
    BUSCAR: 'BUSCAR_MEMBRESIAS',
    SETUP_INTENT: 'SETUP_INTENT_MEMBRESIA',
    PAGOS: 'PAGOS_MEMBRESIA'
};

// Expediente
export const EXPEDIENTE = {
    BUSCAR: 'BUSCAR_ARCHIVOS',
    FILTROS: 'FILTRAR_ARCHIVOS', 
    AGREGAR: 'AGREGAR_ARCHIVO',
    EDITAR: 'EDITAR_ARCHIVO',
    DETALLES: 'DETALLES_ARCHIVO',
    ELIMINAR: 'ELIMINAR_ARCHIVO',
};

// Configuración
export const CONFIGURACION_REGIMENES_FISCALES = {
    BUSCAR: 'BUSCAR_REGIMENES_FISCALES_CONFIGURACION'
};

export const CONFIGURACION_GIROS = {
    BUSCAR: 'BUSCAR_GIROS_CONFIGURACION'
};

export const CONFIGURACION_MEMBRESIAS = {
    BUSCAR: 'BUSCAR_MEMBRESIAS_CONFIGURACION'
};

export const CONFIGURACION_PERFIL = {
    EDITAR_PERSONAL: 'EDITAR_PERFIL_PERSONAL',
    EDITAR_EMPRESARIAL: 'EDITAR_PERFIL_EMPRESARIAL'
};

export const CONFIGURACION_METODO_PAGO = {
    OBTENER: 'OBTENER_METODO_PAGO',
    ACTUALIZAR: 'ACTUALIZAR_METODO_PAGO',
    ELIMINAR: 'ELIMINAR_METODO_PAGO'
};